module.exports = __webpack_public_path__ + "img/thumb-005-04.ae4b6ba5.png";